/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   4/22/22
 */

import React from "react";
import {Stack, Tab, Tabs} from "@mui/material";
import {Link, Outlet, useMatch} from "react-router-dom";

export default function NotificationsContainer() {

	const match = useMatch("/notifications/:tab"), { tab } = match?.params ?? {};

	return (
		<Stack sx={{ p: 1 }}>
			<Tabs
				value={tab || "events"}
				indicatorColor={"primary"}
				sx={{ mb: 1 }}
			>
				<Tab component={Link} value={"events"} label="Events" to={"events"} />
				<Tab component={Link} value={"summaries"} label="Summaries" to={"summaries"} />
			</Tabs>
			<Outlet />
		</Stack>
	);

}